
import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ClickAwayListener from '@mui/material/ClickAwayListener';
import BoltIcon from '@mui/icons-material/Bolt';

import CloseIcon from '@mui/icons-material/Close';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';


import {
  isActionDrawerOpenAtom, currentEntityNameForActionDrawerAtom,
  currentEntityIdForActionDrawerAtom, currentEntityContextualItemsForActionDrawerAtom,
  currentUserSessionAtom,
  colorsAtom
} from 'library/store';

import entityService from 'features/services/Entity';
import BasicButtonList from './ui/BasicButtonList';
import { defaultFeatureDescription, IFeatureDescription, IFeatureParameter } from 'library/interface';
import { isFalsy } from 'utility-types';
import { useForm, useFieldArray, FormProvider } from 'react-hook-form';
import { FormDialog } from './ui/FormDialog';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { useMutation } from 'react-query';
import ArrayField from './ui/ArrayField';

import { arrayFieldFromName } from './ui/DynamicArrayField';


export const EntityActionDrawer = () => {

  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [currentUserSession, setCurrentUserSession] = useRecoilState(currentUserSessionAtom);

  const entityName = useRecoilValue(currentEntityNameForActionDrawerAtom);
  const entityId = useRecoilValue(currentEntityIdForActionDrawerAtom);

  const Colors = useRecoilValue(colorsAtom);

  const entityContextualItems = useRecoilValue(currentEntityContextualItemsForActionDrawerAtom);

  const [openActionParams, setOpenActionParams] = useState<boolean>(false);
  const [openActionComplexParams, setOpenActionComplexParams] = useState<boolean>(false);
  const [actionComplexName, setActionComplexName] = useState<string>('');

  const [openFileParams, setOpenFileParams] = useState<boolean>(false);

  const [isActionDrawerOpen, setIsActionDrawerOpen] = useRecoilState(isActionDrawerOpenAtom);

  const { getParametersByFeature, executeEntityFeature, /*executeEntityFileFeature ,*/getFeaturesByEntityForUser } = entityService();

  const [entityActions, setEntityActions] = useState<IFeatureDescription[]>([]);

  const methodsEntityAction = useForm<IFeatureDescription>({ defaultValues: defaultFeatureDescription });
  const { register, setValue: setEntityActionValue, getValues: getEntityActionValues, watch, reset: resetEntityAction, control, formState: { errors } } = methodsEntityAction;
  let { fields: actionParams } = useFieldArray<IFeatureDescription, 'params'>({
    control,
    name: 'params'
  });

  const { register: registerFile, setValue: setValueFile } = useForm<{ files: FileList }>();

  const { isLoading: isEntityLoading, isError, isSuccess, error, mutate: mutateEntity } = useMutation<any, Error, IFeatureDescription>(executeEntityFeature, {
    onSuccess: (data: any) => {
      enqueueSnackbar(t('_Operation_done'), {
        variant: 'success',
        anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 1000
      });

      const btn = document.getElementById(`btnAfterAction`);
      if (btn == null) {
        // enqueueSnackbar( 'bad action ...', { variant: 'error',
        //   anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
        return;
      }
      btn?.click();

    },
    onError: (err: Error) => {
      enqueueSnackbar(error?.message, {
        variant: 'error',
        anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
      });
    }
  });


  const { isLoading: isEntityFile, mutate: mutateFile } = useMutation<any, Error, IFeatureDescription>(executeEntityFeature, {
    onSuccess: (data: any) => {
      enqueueSnackbar(t('_Operation_done'), {
        variant: 'success',
        anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 1000
      });

      const btn = document.getElementById(`btnAfterAction`);
      if (btn == null) {
        // enqueueSnackbar( 'bad action ...', { variant: 'error',
        //   anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
        return;
      }
      btn?.click();

    },
    onError: (err: Error) => {
      enqueueSnackbar(error?.message, {
        variant: 'error',
        anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
      });
    }
  });

  const handleEntityActionClick = async (actionSelected: IFeatureDescription) => {
    if (actionSelected.type === 0) return;

    const { name: featureName, label: featureLabel } = actionSelected;

    if (isFalsy(featureName)) {
      enqueueSnackbar(t('Invalid feature'), {
        variant: 'error',
        anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
      });
      return;
    }

    const shortName = featureName.endsWith('Handler') ? featureName.substring(0, featureName.length - 7) : featureName;

    if ((actionSelected.inputType === 0) // this is for base feature input
      || (actionSelected.inputType === 1) // this is for complexe input 
    ) {
      const parameters = await getParametersByFeature(entityName, entityId, featureName);

      resetEntityAction({
        ...defaultFeatureDescription, name: featureName, label: featureLabel,
        entityName, entityId, entityContextualItems,
        params: parameters.filter(p => p.name !== 'Id' && p.name !== 'EntityContextualItems').map(p => ({ ...p, fileName: '' }))
      });

      if (actionSelected.inputType === 0)
        setOpenActionParams(true);
      else if (actionSelected.inputType === 1) {

        setActionComplexName(shortName);
        setOpenActionComplexParams(true);
      }
    } else if (actionSelected.inputType === 2) {
      const btn = document.getElementById(`btnAction${shortName}`);
      if (btn == null) {
        enqueueSnackbar('..bad action ...', {
          variant: 'error',
          anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
        });
        return;
      }
      btn?.click();
    } else if (actionSelected.inputType === 3) {
      const parameters = await getParametersByFeature(entityName, entityId, featureName);
      setOpenFileParams(true);
    }


    // const btn = document.getElementById(`btnAction${shortName}`);
    // if(btn == null) {
    //   enqueueSnackbar( 'bad action ...', { variant: 'error',
    //     anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
    //   return;
    // }

    // btn?.click(); 

  }




  const handleOkActionParams = () => {
    setOpenActionParams(false);

    const actionSelected = getEntityActionValues();
    mutateEntity(actionSelected);

    // if( currentObjectKey !== '@UnivList@' && currentObjectKey !== '')
    //   mutateEntity( {...actionSelected, objectDataDef:currentObjectDataDef, objectKey: currentObjectKey  } ); 
    // else
    //   mutateEntities( currentObjectsKey.map( (objKey,idx) => ({...actionSelected,objectDataDef:currentObjectDataDef, objectKey: objKey}) ) ); 
  }

  const handleOkFileActionParams = () => {
    setOpenFileParams(false);

    const actionSelected = getEntityActionValues();
    mutateEntity(actionSelected);
  }

  const [fileName, setFileName] = useState<string>('');
  function openFileDialog() {
    (document as any).getElementById("file-upload-import").click();
  }

  const setFile = (_event: any) => {
    const files = _event.target.files;
    let f = _event.target.files![0];

    if (files)
      setValueFile('files', files);

    var reader = new FileReader();

    reader.onload = function (event: ProgressEvent<FileReader>) {
      try {
        //var binaryString = event.target?.result as string; //  reader.result as string; // event

        setFileName(f.name);

      } catch (err) {
        console.error(err);
      }

    };

    reader.onerror = function () {
      console.log("File load failed");
    };

    reader.readAsArrayBuffer(f);
  }

  useEffect(() => {

    async function loadEntityActions() {

      const { roleEntities } = currentUserSession;

      if (!isActionDrawerOpen) return;

      const entity = roleEntities.find(e => e.entityName === entityName);
      if (!entity || entity == null) {
        setEntityActions([]);
        return;
      }

      const arr = await getFeaturesByEntityForUser(entityName, entityId);

      const actions = arr.filter(a => a.type !== 0 &&
        (entity!.roleEntityFeatures.some(f => f.featureName === a.name) ||

          roleEntities.some(e => e.entityName === entity!.baseEntityName &&
            e.roleEntityFeatures.some(xf => xf.featureName === a.name))));

      setEntityActions(actions);
    }


    loadEntityActions();
  }, [entityName, entityId, isActionDrawerOpen]);

  return (
    <>
      <Drawer open={isActionDrawerOpen} anchor="right" variant="temporary"
        PaperProps={{
          sx: {
            height: 'calc(100vh - 48px)',
            width: 380,
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16,
            boxShadow: '0px 10px 30px rgba(0,0,0,0.18)',
            top: 48
          }
        }}
      >
        <ClickAwayListener onClickAway={() => setIsActionDrawerOpen(false)}>
          <Box display="flex" flexDirection="column" height="100%">
            {/* HEADER */}
            <Box sx={{
              px: 2,
              py: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0, // 🔴 DO NOT SHRINK
            }}>
              <Box display="flex" gap={1} alignItems="center">
                <BoltOutlinedIcon sx={{ fontSize: 22 }} />
                <Typography fontWeight={700}>{t('Actions')}</Typography>
              </Box>
              <IconButton size="small" onClick={() => setIsActionDrawerOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Divider />
            <Box sx={{
              flex: 1,                 // 🔴 TAKES REMAINING SPACE
              overflowY: 'auto',       // 🔴 ONLY THIS SCROLLS
              bgcolor: 'grey.25',
            }}>
            <BasicButtonList<IFeatureDescription> items={entityActions} icon={BoltIcon}
              onItemClick={handleEntityActionClick}
              valueKey={'name'} displayKey={'label'} title={t('Actions')} />

          </Box>
            {/* FOOTER */}
            <Divider />
            <Box sx={{
              p: 1.5,
              display: 'flex',
              justifyContent: 'flex-end',
              flexShrink: 0,  // 🔴 NEVER HIDDEN
              //bgcolor: 'background.paper',
              bgcolor: Colors.background,
            }}>
              <Button onClick={() => setIsActionDrawerOpen(false)}>
                {t('Close')}
              </Button>
            </Box>
          </Box>
        </ClickAwayListener>
      </Drawer>
      {openActionParams && <FormDialog open={openActionParams}
        maxWidth={actionParams.length === 0 ? 'sm' : 'xs'} height={actionParams.length <= 3 ? '55vh' : '90vh'}
        okText='Ok' cancelText={t('Cancel')} title={actionParams.length === 0 ? t('Confirm this action') : t('Parameters')}
        onCancel={() => { setOpenActionParams(false); }}
        onClose={() => { setOpenActionParams(false); }} onOk={handleOkActionParams}  >
        <Box sx={{ mt: 1, width: '100%' }} >
          <FormProvider {...methodsEntityAction} >
            <ArrayField<IFeatureParameter> params={actionParams} itemsPerRow={1} paramsName={'params'}
              valueKey={'value'} labelKey={'label'} dateValueKey='dateValue' />
          </FormProvider>
        </Box>
      </FormDialog>}
      {openActionComplexParams && <FormDialog open={openActionComplexParams} maxWidth='md'
        okText='Ok' cancelText={t('Cancel')} title={t('Parameters')} onCancel={() => { setOpenActionComplexParams(false); }}
        onClose={() => { setOpenActionComplexParams(false); }} onOk={handleOkActionParams}  >
        <FormProvider {...methodsEntityAction} >
          {arrayFieldFromName(actionComplexName, actionParams)}
        </FormProvider>
      </FormDialog>}




    </>

  )
}
